const ENTIDAD_LABELS = {
  Alumno: 'Alumno',
  AlumnoxCarrera: 'Alumno por carrera',
  InscripcionCursadum: 'Inscripción Alumno Cursada',
  InscripcionExaman: 'Inscripción Alumno Examen',
  HistoriaAcademicaCursadum: 'Historia académica de cursada',
  HistoriaAcademicaExaman: 'Historia académica de examen',
  ActaCursadum: 'Acta de cursada',
  ActaExaman: 'Acta de examen',
  DetalleActaCursadum: 'Detalle de acta de cursada',
  DetalleActum: 'Detalle de acta de examen',
  Cursada: 'Cursada',
  MesaExaman: 'Mesa de examen',
  MateriasCarrera: 'Materia',
  Carrera: 'Carrera',
  CorrelatividadesCursar: 'Correlatividad para cursar',
  CorrelatividadesRendir: 'Correlatividad para rendir',
  PeriodoCursadum: 'Período de cursada',
  PeriodoExaman: 'Período de examen',
  AnioAcademico: 'Año académico',
  Usuario: 'Usuario',
  Permiso: 'Permiso',
  UsuarioxPerfil: 'Usuario por perfil',
  EstadoCurricular: 'Estado curricular',
};

/** Opciones del filtro: value = nombre técnico (API), label = nombre visible. */
export const AUDITORIA_ENTIDAD_OPTIONS = Object.entries(ENTIDAD_LABELS)
  .map(([value, label]) => ({ value, label }))
  .sort((a, b) => a.label.localeCompare(b.label, 'es'));

export function formatEntidadNombre(value) {
  const raw = String(value ?? '').trim();
  if (!raw) {
    return '—';
  }

  if (ENTIDAD_LABELS[raw]) {
    return ENTIDAD_LABELS[raw];
  }

  // Proxies EF: InscripcionCursadumProxy → InscripcionCursadum
  if (raw.endsWith('Proxy')) {
    const baseName = raw.slice(0, -'Proxy'.length);
    if (ENTIDAD_LABELS[baseName]) {
      return ENTIDAD_LABELS[baseName];
    }
  }

  return raw;
}

export function formatEntidadId(value) {
  if (value == null || value === '') {
    return '';
  }

  if (typeof value === 'number') {
    return value < 0 ? ' ' : String(value);
  }

  const raw = String(value).trim();
  if (!raw) {
    return '';
  }

  if (/^-?\d+$/.test(raw)) {
    const numeric = Number(raw);
    if (numeric < 0) {
      return ' ';
    }
    return raw;
  }

  return value;
}

export function mapAuditoriaItem(item) {
  if (!item || typeof item !== 'object') {
    return item;
  }

  const rawId = item.auditoriaCambioEntidadId ?? item.AuditoriaCambioEntidadId;
  const rawEntidad = item.auditoriaCambioEntidad ?? item.AuditoriaCambioEntidad;
  const rawUsuario = item.usuarioNombre ?? item.UsuarioNombre;

  return {
    ...item,
    usuarioNombre: rawUsuario,
    auditoriaCambioEntidad: rawEntidad,
    auditoriaCambioEntidadNombre: formatEntidadNombre(rawEntidad),
    auditoriaCambioEntidadId: formatEntidadId(rawId),
  };
}

